
(function () {
  const DYNAMIC_BUNDLE_SELECTOR = '.rebuy-widget.widget-type-dynamic-bundle';
  const ROOT_CLASS = 'rebuy-redesign';
  const MOBILE_MEDIA = '(max-width: 767px)';

  let redesignState = null;

  const waitForRebuyWidget = (element, callback) => {
    const maxWaitTime = 7000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
      const selector = document.querySelector(element);
      if (selector) {
        callback(selector);
        clearInterval(waitingInterval);
      } else {
        elapsedTime += interval;
        if (elapsedTime >= maxWaitTime) {
          clearInterval(waitingInterval);
        }
      }
    }, interval);
  };

  function teardownRedesign() {
    if (!redesignState) return;
    const { widget, observer, grid, originalImages, originalItems } = redesignState;
    observer.disconnect();
    grid.remove();
    widget.classList.remove(ROOT_CLASS, 'rebuy-redesign-active');
    if (originalImages) originalImages.style.display = '';
    if (originalItems) originalItems.style.display = '';
    redesignState = null;
  }

  function createProductCard(productBlock, index) {
    const card = document.createElement('div');
    card.className = `${ROOT_CLASS}__card`;
    card.dataset.index = index;

    const isSelected = productBlock.classList.contains('is-selected');
    if (isSelected) card.classList.add('is-selected');

    const bundleImages = document.querySelectorAll('.rebuy-bundle__image');
    const imageContainer = bundleImages[index];
    const imgEl = imageContainer?.querySelector('img');
    const linkEl = imageContainer?.querySelector('a');

    const titleEl = productBlock.querySelector('.rebuy-product-title');
    const priceContainer = productBlock.querySelector('.rebuy-product-price');
    const reviewEl = productBlock.querySelector('.rebuy-product-review');
    const optionsEl = productBlock.querySelector('.rebuy-product-options');
    const checkboxEl = productBlock.querySelector('.rebuy-checkbox');

    const imgSrc = imgEl?.src || '';
    const imgAlt = imgEl?.alt || '';
    const productUrl = linkEl?.href || titleEl?.href || '#';
    const title = titleEl?.textContent?.trim() || '';

    const salePrice = priceContainer?.querySelector('.rebuy-money.sale')?.textContent?.trim() || '';
    const comparePrice = priceContainer?.querySelector('.rebuy-money.compare-at')?.textContent?.trim() || '';
    const regularPrice = priceContainer?.querySelector('.rebuy-money:not(.sale):not(.compare-at):not(.saved)')?.textContent?.trim() || '';
    const savedAmount = priceContainer?.querySelector('.rebuy-money.saved span:first-child')?.textContent?.trim() || '';
    const hasDiscount = salePrice && comparePrice && salePrice !== comparePrice;
    const displayPrice = hasDiscount ? '' : (regularPrice || comparePrice || salePrice);

    card.innerHTML = `
      <div class="${ROOT_CLASS}__card-image">
        <a href="${productUrl}">
          <img src="${imgSrc}" alt="${imgAlt}" loading="lazy">
        </a>
      </div>
      <div class="${ROOT_CLASS}__card-content">
        <a href="${productUrl}" class="${ROOT_CLASS}__card-title">${title}</a>
        ${reviewEl ? `<div class="${ROOT_CLASS}__card-reviews">${reviewEl.innerHTML}</div>` : ''}
        <div class="${ROOT_CLASS}__card-prices${hasDiscount ? ' has-discount' : ''}">
          <span class="${ROOT_CLASS}__price-sale">${hasDiscount ? salePrice : ''}</span>
          <span class="${ROOT_CLASS}__price-compare">${hasDiscount ? comparePrice : displayPrice}</span>
        </div>
        ${hasDiscount && savedAmount ? `<div class="${ROOT_CLASS}__card-saved">${savedAmount} Saved!</div>` : ''}
        <div class="${ROOT_CLASS}__card-options"></div>
        <div class="${ROOT_CLASS}__card-checkbox">
          <label class="${ROOT_CLASS}__checkbox-label ${isSelected ? 'is-checked' : ''}">
            <span class="${ROOT_CLASS}__checkbox-icon"></span>
            <span class="${ROOT_CLASS}__checkbox-text">${isSelected ? 'Added to Bundle!' : 'Add to Bundle'}</span>
          </label>
        </div>
      </div>
    `;

    if (optionsEl) {
      const optionsContainer = card.querySelector(`.${ROOT_CLASS}__card-options`);
      const clonedOptions = optionsEl.cloneNode(true);
      clonedOptions.className = `${ROOT_CLASS}__options`;
      optionsContainer.appendChild(clonedOptions);

      clonedOptions.querySelectorAll('select').forEach((select, i) => {
        const originalSelect = optionsEl.querySelectorAll('select')[i];
        if (originalSelect) {
          select.value = originalSelect.value;
          select.addEventListener('change', (e) => {
            originalSelect.value = e.target.value;
            originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      });
    }

    const cardCheckbox = card.querySelector(`.${ROOT_CLASS}__checkbox-label`);
    cardCheckbox.addEventListener('click', () => {
      if (checkboxEl) {
        checkboxEl.click();
      }
    });

    return card;
  }

  function updateCardState(card, productBlock) {
    const isSelected = productBlock.classList.contains('is-selected');
    const checkboxLabel = card.querySelector(`.${ROOT_CLASS}__checkbox-label`);
    const checkboxText = card.querySelector(`.${ROOT_CLASS}__checkbox-text`);

    if (isSelected) {
      card.classList.add('is-selected');
      checkboxLabel?.classList.add('is-checked');
      if (checkboxText) checkboxText.textContent = 'Added to Bundle!';
    } else {
      card.classList.remove('is-selected');
      checkboxLabel?.classList.remove('is-checked');
      if (checkboxText) checkboxText.textContent = 'Add to Bundle';
    }

    const priceContainer = productBlock.querySelector('.rebuy-product-price');
    const salePrice = priceContainer?.querySelector('.rebuy-money.sale')?.textContent?.trim() || '';
    const comparePrice = priceContainer?.querySelector('.rebuy-money.compare-at')?.textContent?.trim() || '';
    const regularPrice = priceContainer?.querySelector('.rebuy-money:not(.sale):not(.compare-at):not(.saved)')?.textContent?.trim() || '';
    const savedAmount = priceContainer?.querySelector('.rebuy-money.saved span:first-child')?.textContent?.trim() || '';
    const hasDiscount = salePrice && comparePrice && salePrice !== comparePrice;
    const displayPrice = hasDiscount ? '' : (regularPrice || comparePrice || salePrice);

    const pricesContainer = card.querySelector(`.${ROOT_CLASS}__card-prices`);
    const salePriceEl = card.querySelector(`.${ROOT_CLASS}__price-sale`);
    const comparePriceEl = card.querySelector(`.${ROOT_CLASS}__price-compare`);
    const savedEl = card.querySelector(`.${ROOT_CLASS}__card-saved`);

    if (hasDiscount) {
      pricesContainer?.classList.add('has-discount');
      if (salePriceEl) salePriceEl.textContent = salePrice;
      if (comparePriceEl) comparePriceEl.textContent = comparePrice;
      if (savedEl) savedEl.textContent = `${savedAmount} Saved!`;
    } else {
      pricesContainer?.classList.remove('has-discount');
      if (salePriceEl) salePriceEl.textContent = '';
      if (comparePriceEl) comparePriceEl.textContent = displayPrice;
      if (savedEl) savedEl.textContent = '';
    }
  }

  function initRedesign(widget) {
    widget.classList.add(ROOT_CLASS);

    const bundleEl = widget.querySelector('.rebuy-bundle');
    if (!bundleEl) {
      widget.classList.remove(ROOT_CLASS, 'rebuy-redesign-active');
      return;
    }

    const originalImages = bundleEl.querySelector('.rebuy-bundle__images');
    const originalItems = bundleEl.querySelector('.rebuy-bundle__items');

    if (originalImages) originalImages.style.display = 'none';
    if (originalItems) originalItems.style.display = 'none';

    const productBlocks = widget.querySelectorAll('.rebuy-product-block');
    if (!productBlocks.length) {
      widget.classList.remove(ROOT_CLASS, 'rebuy-redesign-active');
      if (originalImages) originalImages.style.display = '';
      if (originalItems) originalItems.style.display = '';
      return;
    }

    const grid = document.createElement('div');
    grid.className = `${ROOT_CLASS}__grid`;

    productBlocks.forEach((block, index) => {
      const card = createProductCard(block, index);
      grid.appendChild(card);
    });

    bundleEl.insertBefore(grid, bundleEl.querySelector('.rebuy-bundle__actions'));

    const observer = new MutationObserver(() => {
      const cards = grid.querySelectorAll(`.${ROOT_CLASS}__card`);
      cards.forEach((card, index) => {
        const block = productBlocks[index];
        if (block) updateCardState(card, block);
      });
    });

    productBlocks.forEach((block) => {
      observer.observe(block, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
        childList: true,
        characterData: true
      });
    });

    redesignState = {
      widget,
      observer,
      grid,
      originalImages,
      originalItems
    };
  }

  function syncRedesignForViewport(widget, mobileMq) {
    if (mobileMq.matches) {
      if (redesignState && redesignState.widget === widget) return;
      teardownRedesign();
      widget.classList.add('rebuy-redesign-active');
      initRedesign(widget);
    } else {
      teardownRedesign();
    }
  }

  waitForRebuyWidget(DYNAMIC_BUNDLE_SELECTOR, (widget) => {
    const mobileMq = window.matchMedia(MOBILE_MEDIA);
    const onChange = () => syncRedesignForViewport(widget, mobileMq);

    syncRedesignForViewport(widget, mobileMq);

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onChange);
    } else {
      mobileMq.addListener(onChange);
    }
  });
})();
